<template>
    <v-layout row justify-center>
        <v-dialog
            scrollable
            v-model="dialog"
            max-height="80vh"
            max-width="80vw"
            :fullscreen="$vuetify.breakpoint.smAndDown"
        >
            <v-card>
                <v-card-title>
                    <p class="font-weight-medium headline">{{ notification.name }}</p>
                    <p
                        style="position: absolute; top: 60px;"
                    >Enviado em: {{ notification.created_at | formatDateTime }}</p>
                    <v-spacer></v-spacer>
                    <v-layout v-if="approach" column justify-end>
                        <v-layout row justify-end mr-2>
                            <span   :class=" `mx-2 tag-approach-type small ${approach.type}`" >{{approach.type}}</span>
                            <a @click="goToApproach(approach.id)">
                                <p class="subheading">{{'#'+approach.id+' '+ approach.name}}</p>
                            </a>
                        </v-layout>
                        <v-layout row justify-end mr-2>
                            <p v-if="approach.updated_at">Atualizada em {{ approach.updated_at | formatDateTime }}</p>
                        </v-layout>
                    </v-layout>
                    <v-btn flat icon large color="green lighten-2" @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text
                    :style="'padding: 0;' + ($vuetify.breakpoint.smAndDown ? 'height: 55vh' : 'height: 80vh')"
                >
                    <v-layout column>
                        <v-flex md12 style="overflow: auto">
                            <v-tabs v-model="tabs" fixed-tabs slider-color="accent">
                                <!-- , 'Relatório' -->
                                <v-tab
                                    v-for="(item, i) in ['Mensagens','Dia a dia','Estratégia', 'Relatório']"
                                    :key="i"
                                    ripple
                                >{{ item }}</v-tab>
                                <v-tab-item>
                                    <template>
                                        <v-data-table
                                            :items="messages"
                                            class="elevation-0"
                                            :pagination.sync="paginationMensages"
                                            hide-actions
                                            no-data-text="Sem informações até o momento"
                                            :headers="headers"
                                        >
                                            <template v-slot:items="props">
                                                <td
                                                    v-if="notification.approach_type == 'PUSH'"
                                                    class="text-xs-left notification-item-content"
                                                >
                                                    <p>
                                                        <strong>{{ JSON.parse(props.item.message).title }}</strong>
                                                    </p>
                                                    {{ JSON.parse(props.item.message).body }}
                                                </td>
                                                <td
                                                    v-else-if="notification.approach_type == 'EMAIL'"
                                                    class="text-xs-left notification-item-content"
                                                >
                                                    <p>
                                                        {{ JSON.parse(props.item.message).subject }}
                                                    </p>

                                                    <p>
                                                        <a :href="JSON.parse(props.item.message).url" target="_blank">
                                                            {{ JSON.parse(props.item.message).url }}
                                                        </a>
                                                    </p>
                                                </td>
                                                <td
                                                    v-else
                                                    class="text-xs-left notification-item-content"
                                                >
                                                    {{ props.item.message }}
                                                </td>
                                                <td>
                                                    {{ props.item.offer_type_description }}
                                                </td>
                                                <td class="text-xs-center">
                                                    <strong
                                                        style="font-size:16px"
                                                    >{{ props.item.notifications | numeral('0,0') }}</strong>
                                                </td>
                                                <td class="text-xs-center">
                                                    <b
                                                        style="font-size:14px;padding-right: 5px"
                                                    >{{ props.item.accessed_rate | numeral('0.[00]%') }}</b>
                                                    <span
                                                        style="font-size:12px;;"
                                                    >({{ props.item.accessed | numeral('0,0')}})</span>
                                                </td>
                                                <td class="text-xs-center">
                                                    <b
                                                        style="font-size:14px;padding-right: 5px;"
                                                    >{{ props.item.localized_rate | numeral('0.[00]%') }}</b>
                                                    <span
                                                        style="font-size:12px"
                                                    >({{ props.item.localized | numeral('0,0') }})</span>
                                                </td>
                                                <td class="text-xs-center">
                                                    <b
                                                        style="font-size:14px;padding-right: 5px;"
                                                    >{{ props.item.deal_viewed_rate | numeral('0.[00]%') }}</b>
                                                    <span
                                                        style="font-size:12px"
                                                    >({{ props.item.deal_viewed | numeral('0,0') }})</span>
                                                </td>
                                                <td class="text-xs-center">
                                                    <b
                                                        style="font-size:14px;padding-right: 5px;"
                                                   
                                                    > {{ props.item.interest_rate | numeral('0.[00]%') }}</b>
                                                    <span
                                                        style="font-size:12px"
                                                
                                                    >({{ props.item.proposals_confirmed | numeral('0,0')}})</span>
                                                </td>
                                            </template>
                                            <template v-slot:no-data>
                                                <v-container
                                                    fluid
                                                    fill-height
                                                    style="background-color: rgba(255, 255, 255, 0.5);"
                                                >
                                                    <v-layout justify-center align-center>
                                                        <v-progress-circular
                                                            v-if="loading"
                                                            indeterminate
                                                            color="primary"
                                                        ></v-progress-circular>
                                                        <strong
                                                            v-if="!loading"
                                                            class="py-2"
                                                            style="font-color:red;font-size:14px"
                                                        >Sem informações até o momento</strong>
                                                    </v-layout>
                                                </v-container>
                                            </template>
                                            <template v-slot:footer>
                                                <td class="pt-2">
                                                    <p class="pa-0 font-weight-bold title">Total</p>
                                                </td>
                                                <td>&nbsp;</td>
                                                <td class="text-xs-center">
                                                    <p
                                                        class="font-weight-bold subheading"
                                                    >{{notification.notifications | numeral('0,0')}}</p>
                                                </td>
                                                <td class="text-xs-center">
                                                    <p
                                                        class="font-weight-bold subheading"
                                                    >{{notification.accessed | numeral('0,0')}}</p>
                                                </td>
                                                <td class="text-xs-center">
                                                    <p
                                                        class="font-weight-bold subheading"
                                                    >{{notification.localized | numeral('0,0')}}</p>
                                                </td>
                                                <td class="text-xs-center">
                                                    <p
                                                        class="font-weight-bold subheading"
                                                    >{{notification.deal_viewed | numeral('0,0')}}</p>
                                                </td>
                                                <td class="text-xs-center">
                                                    <p
                                                        class="font-weight-bold subheading"
                                                    >{{notification.proposals_confirmed | numeral('0,0')}}</p>
                                                </td>
                                            </template>
                                        </v-data-table>
                                    </template>
                                </v-tab-item>
                                <v-tab-item>
                                    <template>
                                        <v-data-table
                                            :headers="headers2"
                                            :items="desserts"
                                            class="hover-table"
                                            style="box-shadow: none !important;"
                                            no-data-text="Sem informações até o momento"
                                            hide-actions
                                        >
                                            <template v-slot:items="props" class>
                                                <td>{{  props.item.dia.split('-').reverse().join('/') }}</td>
                                                <td
                                                    :class="['text-xs-center', colorTextStatus(props.item.acessos.status)]"
                                                >
                                                    <b>{{ calcPorcentagem(props.item.acessos.val, notification.notifications)+'%' }}</b>
                                                    <v-icon
                                                        style="font-size: 16px;"
                                                        :class="['text-xs-center', colorTextStatus(props.item.acessos.status)]"
                                                    >{{ iconStatus(props.item.acessos.status) }}</v-icon>
                                                    <span
                                                        style="font-size: 10px;padding-left: 5px;"
                                                    >({{ props.item.acessos.val }})</span>
                                                </td>
                                                <td
                                                    :class="['text-xs-center', colorTextStatus(props.item.confirmadas.status)]"
                                                >
                                                    <b>{{ (props.item.confirmadas.val / props.item.acessos.val) | numeral('0.[00]%')  }}</b>
                                                    <v-icon
                                                        style="font-size: 16px;"
                                                        :class="['text-xs-center', colorTextStatus(props.item.confirmadas.status)]"
                                                    >{{ iconStatus(props.item.confirmadas.status) }}</v-icon>
                                                    <span
                                                        style="font-size: 10px;padding-left: 5px;"
                                                    >({{  props.item.confirmadas.val}})</span>
                                                </td>
                                                <td
                                                    :class="['text-xs-center', colorTextStatus(props.item.localizados.status)]"
                                                >
                                                    <b>({{ calcPorcentagem(props.item.confirmadas.val, notification.notifications) }}%)</b>
                                                    <v-icon
                                                        style="font-size: 16px;"
                                                        :class="['text-xs-center', colorTextStatus(props.item.localizados.status)]"
                                                    >{{ iconStatus(props.item.localizados.status) }}</v-icon>
                                                    <span
                                                        style="font-size: 10px;padding-left: 5px;"
                                                    >({{  props.item.localizados.val }})</span>
                                                </td>
                                                <td
                                                    :class="['text-xs-center', colorTextStatus(props.item.deal_viewed.status)]"
                                                >
                                                    <b>{{ (props.item.deal_viewed.val / props.item.localizados.val) | numeral('0.[00]%')  }}</b>
                                                    <v-icon
                                                        style="font-size: 16px;"
                                                        :class="['text-xs-center', colorTextStatus(props.item.deal_viewed.status)]"
                                                    >{{ iconStatus(props.item.deal_viewed.status) }}</v-icon>
                                                    <span
                                                        style="font-size: 10px;padding-left: 5px;"
                                                    >({{  props.item.deal_viewed.val }})</span>
                                                </td>
                                            </template>
                                            <template v-slot:footer>
                                                <td class="f-td">Total</td>
                                                <td class="f-td text-xs-center">
                                                    <span>({{ notification.accessed_rate | numeral('0.[00]%') }})</span>
                                                    {{ notification.accessed }}
                                                </td>
                                                <td class="f-td text-xs-center">
                                                    <span>({{ notification.proposals_localized_rate | numeral('0.[00]%') }})</span>
                                                    {{ notification.localized }}
                                                </td>
                                                <td class="f-td text-xs-center">
                                                    <span>({{ notification.deal_viewed_rate | numeral('0.[00]%') }})</span>
                                                    {{ notification.deal_viewed }}
                                                </td>
                                                <td class="f-td text-xs-center">
                                                    <span>({{ notification.proposals_confirmed_rate | numeral('0.[00]%') }})</span>
                                                    {{ notification.proposals_confirmed }}
                                                    
                                                </td>
                                            </template>
                                        </v-data-table>
                                    </template>
                                </v-tab-item>
                                <v-tab-item>
                                    <StrategyOverview
                                        :strategy="this.notification.strategy_snapshot"
                                        :creditor="this.notification.creditor_name"
                                    ></StrategyOverview>
                                </v-tab-item>
                                <v-tab-item>
                                    <TableReporting
                                        @pagination="pagination = $event"
                                        :pagination="pagination"
                                        :reports="reports"
                                        :doneFetching="doneFetching"
                                        styleTable
                                    ></TableReporting>
                                </v-tab-item>
                            </v-tabs>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="newReport(notification.id)"
                        :loading="loadingNewReport"
                        :disabled="loadingNewReport"
                        color="secondary"
                        flat
                    >Extrair relatório analítico</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import strategyNotificationService from "@/services/notification-history";
import TableReporting from "@/components/reporting/TableReporting";
import reportingService from "@/services/reporting/reporting";
import StrategyOverview from "@/components/StrategyOverview";
import { EventBus } from "@/services/event-bus";
export default {
    mounted() {
        this.tabs = 0;
        ("up");
    },
    components: {
        StrategyOverview,
        TableReporting,
    },
    data() {
        return {
            doneFetching: false,
            reports: {},
            approach:{},
            query: {},
            pagination: {
                descending: true,
                page: 1,
                rowsPerPage: 5,
                sortBy: "updated_at",
                totalItems: 0,
                rowsPerPageItems: [5, 10, 25, 50, 100],
            },
            paginationMensages: {
                descending: true,
                page: 1,
                rowsPerPage: 50,
                sortBy: "accessed_rate",
            },
            loadingNewReport: false,
            dialog: false,
            messages: [],
            loading: false,
            notification: {},
            tabs: null,
            headers: [
                {
                    text: "Mensagem",
                    align: "left",
                    sortable: false,
                    value: "message",
                    width: "50%",
                },
                {
                    text: "Tipo da Oferta",
                    value: "offer_type_description",
                    align: "left",
                    sortable: true,
                    width: "10%",
                },
                {
                    text: "Notificações",
                    value: "notifications",
                    align: "center",
                    sortable: true,
                    width: "10%",
                },
                {
                    text: "Interesse",
                    value: "accessed_rate",
                    align: "center",
                    sortable: true,
                    width: "10%",
                },
                {
                    text: "Localizados",
                    value: "localized_rate",
                    align: "center",
                    width: "10%",
                    sortable: true,
                },
                {
                    text: "Deal Visualizado",
                    value: "deal_viewed_rate",
                    align: "center",
                    width: "10%",
                    sortable: true,
                },
                {
                    text: "Conversão",
                    value: "interest_rate",
                    align: "center",
                    sortable: true,
                    width: "10%",
                },
            ],
            headers2: [
                { text: "Dia", value: "dia" },
                { text: "Interesse", value: "acessos", align: "center" },
                { text: "Localizados", value: "localizados", align: "center" },
                { text: "Deal Visualizado", value: "deal_viewed", align: "center" },
                { text: "Conversão", value: "confirmadas", align: "center" },
            ],
            desserts: [],
        };
    },
    watch: {
        async dialog() {
            if (this.dialog) {
                
                await this.getNotificationMessages(this.notification.id);

                if(this.notification.strategy_snapshot && this.notification.strategy_snapshot.approach) 
                    this.approach = this.notification.strategy_snapshot.approach
                else
                    this.approach = JSON.parse(this.notification.strategy_snapshot).approach

            }
            EventBus.$emit(
                "notificationHistoryModal",
                this.dialog,
                this.notification.id
            );
        },
        pagination: {
            async handler() {
                if (this.doneFetching) {
                    this.searchReports();
                }
            },
            deep: true,
        },
    },
    methods: {
        searchReports() {
            strategyNotificationService
                .get(this.notification.id)
                .then((res) => {
                    this.reports = res;
                    this.loadingNewReport = false;
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        newReport(id) {
            this.loadingNewReport = true;
            reportingService
                .generateReport("FIRING", [id])
                .then((resp) => {
                    this.$store.commit(
                        "showSnackbar",
                        "Relatório gerado com sucesso."
                    );
                    strategyNotificationService
                        .get(id)
                        .then((res) => {
                            this.reports = res;
                            this.loadingNewReport = false;
                        })
                        .catch((err) => {
                            this.loadingNewReport = false;
                            console.error(err);
                        });
                })
                .catch((err) => {
                    this.loadingNewReport = false;
                    console.error(err);
                    this.$store.commit(
                        "showSnackbar",
                        "Houve um erro ao gerar o relatório."
                    );
                });
        },
        open(notification) {
            this.notification = notification;
            this.messages = [];
            this.dialog = !this.dialog;
            strategyNotificationService
                .dayByDay(this.notification.id)
                .then((res) => {
                    this.desserts = [];
                    var lastValAcessos = 0;
                    var lastValLocalizados = 0;
                    var lastValDealViewed = 0;
                    var lastValConfirmadas = 0;

                    for (var [key, value] of Object.entries(res)) {
                        let statusAcessos = this.status(
                            value.accessed,
                            lastValAcessos
                        );
                        let statusLocalizados = this.status(
                            value.localized,
                            lastValLocalizados
                        );
                        let statusDealViewed = this.status(
                            value.deal_viewed || 0,
                            lastValDealViewed
                        );
                        let statusConfirmadas = this.status(
                            value.proposals_confirmed,
                            lastValConfirmadas
                        );

                        this.desserts.push({
                            dia: key,
                            acessos: {
                                val: value.accessed,
                                porc: 12,
                                status: statusAcessos,
                            },
                            localizados: {
                                val: value.localized,
                                porc: 12,
                                status: statusLocalizados,
                            },
                            deal_viewed: {
                                val: value.deal_viewed || 0,
                                porc: 12,
                                status: statusDealViewed,
                            },
                            confirmadas: {
                                val: value.proposals_confirmed,
                                porc: 12,
                                status: statusConfirmadas,
                            },
                        });

                        lastValAcessos = value.accessed;
                        lastValLocalizados = value.localized;
                        lastValDealViewed = value.deal_viewed || 0;
                        lastValConfirmadas = value.proposals_confirmed;
                    }
                });
            this.searchReports();
        },
        async getNotificationMessages(notification_id) {
            this.loading = true;
            await strategyNotificationService
                .fetchNotificationMessages(notification_id)
                .then((res) => {
                    this.messages = res;
                    this.messages = this.messages
                        .sort((a, b) => {
                            if (a.localized_rate < b.localized_rate) return -1;
                            if (a.localized_rate > b.localized_rate) return 1;
                            return 0;
                        })
                        .reverse();
                })
                .catch((err) => {
                    // f - td;
                    console.error(err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        status(value, lestValue) {
            let status = "up";
            if (value == lestValue) {
                status = "neutral";
            } else if (value < lestValue) {
                status = "down";
            }
            return status;
        },
        colorTextStatus(status) {
            let color = "green--text";
            if (status == "neutral") {
                color = "orange--text";
            } else if (status == "down") {
                color = "red--text";
            }
            return color;
        },
        iconStatus(status) {
            let icon = "arrow_upward";
            if (status == "neutral") {
                icon = "remove";
            } else if (status == "down") {
                icon = "arrow_downward";
            }
            return icon;
        },
        calcPorcentagem(val, total) {
            if (val <= 0) return 0;
            let resp = (val * 100) / total;
            return resp.toFixed(3);
        },
        goToApproach(approach_id){
            this.$router.push({
                name: "Abordagem",
                params: {
                    edit: true,
                    approach_id
                },
            });
        },
    },
};
</script>

<style>
.hover-table table tbody tr:hover {
    background: #e9e9e9 !important;
}
table tfoot tr .f-td {
    font-weight: bold;
    font-size: 16px;
}

table tfoot tr .f-td span {
    font-size: 12px;
}
table thead .v-datatable__progress th.column:first-child {
    padding: 0 !important;
}

.notification-item-content a {
    text-decoration: none;
}
</style>
